import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center mt-20" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  type: "submit",
  class: "c-button min-w-100"
}
const _hoisted_4 = {
  key: 1,
  class: "max-w-700"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: "unconfirmedProfile" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["onClick"]

import { computed, Ref } from 'vue';
import { Form } from 'vee-validate';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import { B2CMyBoliaProfileModel, B2CUpdateProfileRequest } from '@/b2c/shared/api/server-apis';
import profileStore, { B2CProfileEditMode } from '@/b2c/profile/profile.store';
import ProfileInfoItem from '@/b2c/profile/ui/ProfileInfoItem.vue';
import ProfileBirthdayInput from '@/b2c/profile/ui/ProfileBirthdayInput.vue';
import useBirthday from '@/b2c/profile/useBirthday';
interface IMyBoliaProfileInfoForm {
    firstName: string;
    lastName: string;
    email: string;
    birthdayDate: string | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileInfo',
  props: {
    confirmEmailSettings: null
  },
  setup(__props: any) {

const props = __props as {
    confirmEmailSettings: string;
}

const { birthdayDateAsFormattedString } = useBirthday();


const editProfileWebApiMessageKey = 'editProfileApiMessages';
const labels = useBlockLabels();
const profile: Ref<B2CMyBoliaProfileModel> = computed(() => profileStore.profile);
const editMode: Ref<boolean> = computed(() => profileStore.isInformationEditMode);

const getDefaultEditValues = (): IMyBoliaProfileInfoForm => ({
    firstName: profile.value.firstName ?? '',
    lastName: profile.value.lastName ?? '',
    email: profile.value.unconfirmedEmail || profile.value.email,
    birthdayDate: profile.value.birthday,
});

const formatSubmit = async(params: IMyBoliaProfileInfoForm): Promise<void> => {
    const formattedParams = {
        firstName: params.firstName,
        lastName: params.lastName,
        email: params.email,
        birthday: params.birthdayDate ?? undefined,
    };
    const request: B2CUpdateProfileRequest = {
        ...formattedParams,
        confirmEmailSettings: props.confirmEmailSettings,
    };
    await submit(request);
};

const submit = async(request: B2CUpdateProfileRequest) => {
    await profileStore.updateProfileInformation(request, editProfileWebApiMessageKey);
    profileStore.clearEditMode();
};

const cancelEmailChange = async(): Promise<void> => {
    const {
        firstName,
        lastName,
        email,
        birthday,
    } = profile.value;
    if (firstName && lastName && email && birthday) {
        await submit({
            firstName,
            lastName,
            email,
            birthday,
            confirmEmailSettings: props.confirmEmailSettings,
        });
    }
};

const setEditMode = (): void => {
    profileStore.setEditMode(B2CProfileEditMode.Information);
};

const clearEditMode = (): void => {
    profileStore.clearEditMode();
};

const formValidation = {
    firstName: 'required',
    lastName: 'required',
    email: 'required|email',
    birthdayIsValidOrNull: 'required',
    birthDay: 'calenderDay',
    birthMonth: 'calenderMonth',
    birthYear: 'calenderYear',
};


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_unref(editMode))
      ? (_openBlock(), _createBlock(_unref(Form), {
          key: 0,
          "initial-values": getDefaultEditValues(),
          "validation-schema": formValidation,
          class: "mt-30 max-w-500",
          onSubmit: formatSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              name: "firstName",
              label: _unref(labels).firstNameLabel,
              autofocus: true
            }, null, 8, ["label"]),
            _createVNode(_component_InputText, {
              name: "lastName",
              label: _unref(labels).lastNameLabel
            }, null, 8, ["label"]),
            _createVNode(ProfileBirthdayInput),
            _createVNode(_component_InputText, {
              name: "email",
              label: _unref(labels).emailLabel,
              type: "email",
              disabled: ""
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "text-dusty-grey c-magic-line mr-40",
                onClick: _withModifiers(clearEditMode, ["prevent"])
              }, _toDisplayString(_unref(labels).editMyInformationCancelButton), 9, _hoisted_2),
              _createElementVNode("button", _hoisted_3, _toDisplayString(_unref(labels).editMyInformationSaveButton), 1)
            ]),
            _createVNode(WebApiMessage, {
              id: editProfileWebApiMessageKey,
              "clear-timing": 3000,
              class: "mt-30"
            })
          ]),
          _: 1
        }, 8, ["initial-values"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "text-dusty-grey c-magic-line mb-15",
            onClick: _withModifiers(setEditMode, ["prevent"])
          }, _toDisplayString(_unref(labels).editMyInformationButton), 9, _hoisted_5),
          _createVNode(ProfileInfoItem, {
            title: _unref(labels).fullNameLabel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(profile).firstName) + " " + _toDisplayString(_unref(profile).lastName), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ProfileInfoItem, {
            title: _unref(labels).birthday
          }, {
            default: _withCtx(() => [
              (_unref(birthdayDateAsFormattedString))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(birthdayDateAsFormattedString)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ProfileInfoItem, {
            title: _unref(labels).emailLabel
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(profile).email), 1),
              _createVNode(_Transition, { name: "o-anim-fade-300" }, {
                default: _withCtx(() => [
                  (_unref(profile).unconfirmedEmail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "mb-5",
                          innerHTML: _ctx.$dictionary.formatNamed(_unref(labels).unconfirmedEmailDescription, { email: _unref(profile).unconfirmedEmail })
                        }, null, 8, _hoisted_9),
                        _createElementVNode("button", {
                          class: "text-dusty-grey c-magic-line mb-20",
                          onClick: _withModifiers(cancelEmailChange, ["prevent"])
                        }, _toDisplayString(_unref(labels).cancelEmailChangeButton), 9, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]))
  ]))
}
}

})